import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
interface HeroProps {
  onBuyClick?: () => void;
}
export function Hero({
  onBuyClick
}: HeroProps) {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-48">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-49">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-rose-400/20 blur-3xl" data-id="element-50" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-gold/10 blur-3xl" data-id="element-51" />
      </div>

      <div className="max-w-5xl mx-auto text-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-53">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-chocolate-light text-sm font-bold tracking-widest uppercase mb-6" data-id="element-54">
            Programa Repostería Emprendedora
          </span>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-chocolate" data-id="element-55">
            Cómo pasar de Ama de Casa a Dueña de un Negocio de Pastelería
            Premium facturando tus primeros{' '}
            <span className="text-rose-600 italic" data-id="element-56">+$500 USD/mes</span> desde
            Instagram...
            <br className="hidden md:block" data-id="element-57" />
            <span className="text-3xl md:text-4xl lg:text-5xl mt-4 block font-medium text-chocolate-light" data-id="element-58">
              Sin Horno Profesional y Sin Salir de tu Cocina.
            </span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-chocolate-light max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-59">
          Domina las técnicas de la pastelería francesa y los postres de alta
          rotación, mientras aplicas la estrategia exacta para llenar tu
          WhatsApp de pedidos reales todos los días.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-60">
          <Button onClick={() => {
          document.getElementById('pricing-cta')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-61">
            ¡SÍ, QUIERO MI NEGOCIO DE REPOSTERÍA!
          </Button>
          <p className="mt-4 text-sm text-chocolate-light/80 flex items-center gap-2" data-id="element-62">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-63" />
            Acceso inmediato. Pago seguro.
          </p>
        </motion.div>

        {/* Hero Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-16 relative max-w-4xl mx-auto" data-id="element-64">
          <div className="rounded-2xl overflow-hidden shadow-2xl shadow-chocolate/10 relative" data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/g9LhizhyUzHT6EmAkMLLFL/8_en_1.png" alt="Repostera Pro: Pack Emprendedor (8 en 1)" className="w-full h-auto object-contain" data-id="element-66" />
          </div>
        </motion.div>
      </div>
    </section>;
}